import React, {useEffect, useState} from 'react';
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import { useForm } from "react-hook-form";
import {sanitizePhoneNumber} from "../../utils/utilsHelpers";
import Modal from "react-bootstrap/Modal";


export default function UserDetails(props) {

    const { register, handleSubmit, formState: { errors, isValid, isSubmitting }} = useForm();
    const [cta, setCta] = useState('Update your details');

    const renderFormFields = () => {
        return (
            <>
                <Form.Group className="mb-3 text-start">
                    <Form.Control
                        id='user_first_name'
                        placeholder='First name'
                        defaultValue={props.userSignedIn && props.currentUser?.first_name}
                        {...register("user.first_name", { pattern: { value: /^([^0-9]*)$/g, message: 'First name cannot contain numbers' } })} />
                    {errors.user?.first_name && <Form.Text className="text-danger">{errors.user.first_name.message}</Form.Text>}
                </Form.Group>

                <Form.Group className="mb-3 text-start">
                    <Form.Control
                        id='user_last_name'
                        placeholder='Last name'
                        defaultValue={props.userSignedIn && props.currentUser?.last_name}
                        {...register("user.last_name", { pattern: { value: /^([^0-9]*)$/g, message: 'Last name cannot contain numbers' } })} />
                    {errors.user?.last_name && <Form.Text className="text-danger">{errors.user.last_name.message}</Form.Text>}
                </Form.Group>

                <Form.Group className="mb-3 text-start">
                    <Form.Control
                        id='user_job_title'
                        placeholder='Job title'
                        defaultValue={props.userSignedIn && props.currentUser?.job_function}
                        {...register("user.job_function", { /*required: 'This field is required'*/ })} />
                    {errors.user?.job_function && <Form.Text className="text-danger">{errors.user.job_function.message}</Form.Text>}
                </Form.Group>

                <Form.Group className="mb-3 text-start">
                    <Form.Control
                        id='user_company_name'
                        placeholder='Company name'
                        defaultValue={props.userSignedIn && props.currentUser?.company_name}
                        {...register("user.company_name", { /*required: 'This field is required'*/ })} />
                    {errors.user?.company_name && <Form.Text className="text-danger">{errors.user.company_name.message}</Form.Text>}
                </Form.Group>

            </>
        )
    }

    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }

    const onUpdateDetails = async(data) => {
        setCta('Updating...');
        await fetch('/users/update_user_details', {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify({ authenticity_token: props.token, ...data })
        }).then(function(response) {
            return response.json();
        }).then(function(jsonResponse) {
            props.onNextModal({ redirect_path: jsonResponse?.redirect_path });
        })
    }

    return (
        <>
            <Modal.Header className={'border-bottom-0 pt-4 pb-0 justify-content-center text-center'}>
                <Modal.Title className={'fs-4 mb-0'}>
                    Complete sign-up
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className={'text-secondary text-center px-2 px-sm-4 mx-1 pt-0'}>
                <div className={'mb-4 secondary-links fs-6 w-75 mx-auto'}>
                    Share a few more details so we can provide specific suggestions for you
                </div>

                <Form noValidate={true} onSubmit={handleSubmit(onUpdateDetails)}>
                    {renderFormFields()}
                    <Button variant="primary" type="submit" className={'btn-block btn-hover-cursor mt-3'} disabled={isSubmitting}>
                        {cta}
                    </Button>
                </Form>

            </Modal.Body>
        </>
    )
}